import $ from 'jquery';

Drupal.behaviors.thrilledStatusMessages = {
  attach: function (context) {
    const $button = $('.close-status-message', context);

    $button.once('thrilledStatusMessages').on('click', function() {
      let $region = $(this).closest('.status-message'),
          ariaHidden = $region.attr('aria-hidden');
      $region.addClass('status-message--hidden');

      if (ariaHidden === 'false') {
        $region.attr('aria-hidden', 'true');
      }
    });
  }
};
